<template>
  <div class="text-left">
    <p class="sub-header mb-4">
      A következő adatok kitöltése nem kötelező, de befolyásolhatja a megjeleníthető lehetőségek számát és
      relevanciáját.
    </p>

    <CompanyAttributeSection
      title="Milyen tevékenységre keres forrást?"
      description="Válassza ki a cégének azt a tevékenységi körét, amelyhez keresi a finanszírozási forrást, vagy jelöljön meg új tevékenységi kört."
    >
      <section v-if="this.fundMapCompany.imaginaryCompany">
        <div class="radio-box" v-for="option in teaorOptions" :key="option">
          <input type="radio" :id="option" :value="option" v-model="selectedTeaor" />
          <label class="radio-text" :for="option">{{ mapNameToTeaorCode(option) }}</label>
        </div>
      </section>
      <section v-else>
        <div class="radio-box" v-for="option in teaorOptions" :key="option.value">
          <input type="radio" :id="option.value" :value="option.value" v-model="selectedTeaor" />
          <label class="radio-text" :for="option.value">{{ mapNameToTeaorCode(option.value) }}</label>
        </div>
      </section>

      <b-row style="margin-top:10px;">
        <div class="radio-box" style="margin-left: 15px; ">
          <input type="radio" id="Egyéb-teaor" value="Egyéb-teaor" v-model="selectedTeaor" />
          <label class="radio-text" for="Egyéb-teaor">Egyéb</label>
        </div>
        <b-col cols="9" lg="6" xl="6">
          <TeaorSelector
            :disabled="selectedTeaor !== 'Egyéb-teaor'"
            :alreadySelected="alreadySelectedTeaor"
            :showError="this.showTeaorComponentErrorMessage"
            listType="fourDigit"
            @selected-teaor="addOtherTeaor($event)"
          />
        </b-col>
      </b-row>

      <p class="disclaimer" v-if="!this.fundMapCompany.imaginaryCompany">
        Elképzelhető, hogy a megjelenített tevékenységi körök listája nem teljes körű. Amennyiben nem jelenik meg a
        listában az a tevékenyési kör, amire forrást keres, használja az egyéb opciót.
      </p>
    </CompanyAttributeSection>

    <CompanyAttributeSection
      title="Hol szeretné felhasználni a forrást?"
      description="Válasszon a székhelye, telephelyei között, vagy adjon meg új helyszínt, ahol a forrást felhasználná."
    >
      <section v-if="this.fundMapCompany.imaginaryCompany">
        <div class="radio-box" v-for="option in zipOptions" :key="option.zipCode">
          <input type="radio" :id="option.zipCode" :value="option.zipCode" v-model="selectedZip" />
          <label class="radio-text" :for="option.zipCode">{{ mapNameToZipCode(option.zipCode) }}</label>
        </div>
      </section>
      <section v-else>
        <div class="radio-box" v-for="addressOption in zipOptions" :key="addressOption.address">
          <input type="radio" :id="addressOption.address" :value="addressOption" v-model="selectedZip" />
          <label class="radio-text" :for="addressOption.address">{{ addressOption.address }}</label>
        </div>
      </section>

      <b-row style="margin-top:10px;">
        <div class="radio-box" style="margin-left: 15px;">
          <input type="radio" id="Egyéb-zip" value="Egyéb-zip" v-model="selectedZip" />
          <label class="radio-text" for="Egyéb-zip">Egyéb</label>
        </div>
        <b-col cols="9" lg="6" xl="6">
          <ZipCodeSelector
            :disabled="selectedZip !== 'Egyéb-zip'"
            :alreadySelected="alreadySelectedZip"
            :showError="this.showZipComponentErrorMessage"
            @selected-zipCode="addOtherZip($event)"
          />
        </b-col>
      </b-row>

      <p class="disclaimer" v-if="!this.fundMapCompany.imaginaryCompany">
        Elképzelhető, hogy a megjelenített telephelyek listája nem teljes körű. Amennyiben nem jelenik meg a listában az
        a telephely, ahol felhasználná a forrást, használja az egyéb opciót.
      </p>
    </CompanyAttributeSection>

    <CompanyAttributeSection
      title="Kapott támogatást az alábbi pályázati felhívások keretében?"
      description="A pontosabb találat érdekében jelölje meg milyen támogatást vett igénybe, mert ezek bizonyos forrásoknál kizáró tényezők lehetnek."
      :hide="!!this.fundMapCompany.imaginaryCompany || this.applications.length == 0"
    >
      <ApplicationRestrictions
        :data="this.applications"
        @application-restriction-ids="handleRestrictions($event)"
        :preSelection="restrictions"
      />
    </CompanyAttributeSection>

    <CompanyAttributeSection title="Az Ön vállalkozása beszállítója más vállalatoknak?" description="">
      <b-form-checkbox
        id="checkbox-isSupplier"
        v-model="isSupplier"
        name="checkbox-isSupplier"
        :value="isSupplier.value"
        :unchecked-value="isSupplier.value"
        class="mt-3"
      >
        <p class="checkbox-label">
          Igen, a vállalkozásom beszállító.
        </p>
      </b-form-checkbox>
    </CompanyAttributeSection>

    <CompanyAttributeSection
      title="A vállalkozásának árbevétele főleg mezőgazdasági tevékenységből származott?"
      description=""
    >
      <b-form-checkbox
        id="checkbox-revenueFromAggriculture"
        v-model="revenueFromAggriculture"
        name="checkbox-revenueFromAggriculture"
        :value="revenueFromAggriculture.value"
        :unchecked-value="revenueFromAggriculture.value"
        class="mt-3"
      >
        <p class="checkbox-label">
          Igen, a vállalkozásom árbevételének legalább 50%-a mezőgazdasági tevékenységből származott az előző pénzügyi
          évben.
        </p>
      </b-form-checkbox>
    </CompanyAttributeSection>

    <CompanyAttributeSection
      title="Aktualizálja cége pénzügyi adatait."
      description="Amennyiben a pályázat, hitelkérelem, vagy tőkeigénylés benyújtásáig közzéteszi a gazdasági adatait, frissítheti azokat a 2. oszlopban. Így a Forrástérkép az aktualizált számokkal fog kalkulálni."
      :hide="!!this.fundMapCompany.imaginaryCompany"
    >
      <div class="d-none d-md-flex">
        <div class="col"></div>
        <h3 class="col table-title-header">Előző lezárt pénzügyi év adatai (2022)</h3>
        <h3 class="col table-title-header">Frissített gazdasági adatok</h3>
      </div>
      <CompanyAttributeCalculator
        v-for="attribute in this.attributesToCalculate"
        :title="attribute.title"
        :amount="attribute.amount"
        :measurement="attribute.measurement"
        :keyInStore="attribute.keyInStore"
        :key="attribute.key"
        :alreadySelected="calculatorAlreadySelected(attribute.keyInStore)"
        @multiplied-attribute="handleMultipliedAttribute"
      />
    </CompanyAttributeSection>

    <div>
      <b-button class="btn mt-2 mr-2 link-button btn-primary" @click="prev" style="min-width: 150px;">
        Vissza
      </b-button>
      <b-button class="btn mt-2 link-button btn-primary" @click="next" variant="primary" style="min-width: 150px;">
        Tovább
      </b-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import * as CompetitionApi from '../../../api/competition'
import CompanyAttributeCalculator from '../../../components/CompanyAttributeCalculator.vue'
import CompanyAttributeSection from '../../../components/CompanyAttributeSection.vue'
import teaorList from '../../../components/TeaorSelector/teaor'
import TeaorSelector from '../../../components/TeaorSelector/TeaorSelector.vue'
import zipCodes from '../../../components/zipCodeSelector/zipCodes'
import ZipCodeSelector from '../../../components/zipCodeSelector/zipCodeSelector.vue'
import errorToast from '../../../mixins/toastError'
import ApplicationRestrictions from '../../FundCreation/components/ApplicationRestrictions'
export default {
  mixins: [errorToast],
  data() {
    return {
      filterList: [],
      selectedCategories: {},
      selectedCompany: {},
      selectedTeaor: '',
      selectedZip: '',
      alreadySelectedZip: '',
      alreadySelectedTeaor: '',
      isSupplier: false,
      revenueFromAggriculture: false,
      showZipComponentErrorMessage: false,
      showTeaorComponentErrorMessage: false,
      applications: [],
      restrictions: [],
      zipCodes,
      teaorList
    }
  },
  components: {
    TeaorSelector,
    CompanyAttributeSection,
    ZipCodeSelector,
    CompanyAttributeCalculator,
    ApplicationRestrictions
  },
  computed: {
    ...mapGetters(['isAuthenticated', 'fundMapCompany', 'selectedFundMapCategory', 'fundMapCompanyAttributes']),
    teaorOptions() {
      if (this.fundMapCompany.activities) {
        const mainActivities = this.fundMapCompany.main_activities
        const subActivities = this.fundMapCompany.activities
          .filter(
            activity =>
              !activity.is_main_activity && activity.nace_number != this.fundMapCompany.main_activities[0].nace_number
          )
          .slice(0, 5)

        return [...this.mapActivityToCheckbox(mainActivities), ...this.mapActivityToCheckbox(subActivities)]
      } else if (this.fundMapCompany.imaginaryCompany) {
        const createdCompanyOptions = []
        createdCompanyOptions.push(this.fundMapCompany.imaginaryCompany.mainTeaor)
        this.fundMapCompany.imaginaryCompany.secondaryTeaors.map(secondaryTeaor => {
          createdCompanyOptions.push(secondaryTeaor.teaorCode)
        })
        return createdCompanyOptions.slice(0, 6)
      }
      return []
    },
    zipOptions() {
      let mappedZipOptions = []

      if (this.fundMapCompany.imaginaryCompany) {
        mappedZipOptions.push({ ...mappedZipOptions, zipCode: this.fundMapCompany.imaginaryCompany.address })
        if (this.fundMapCompany.imaginaryCompany.sites) {
          this.fundMapCompany.imaginaryCompany.sites.map(site => {
            mappedZipOptions.push(site)
          })
        }
      } else {
        if (this.fundMapCompany.address) {
          this.fundMapCompany.address.map(address => {
            mappedZipOptions.push(address)
          })
        }
        if (this.fundMapCompany.branches) {
          this.fundMapCompany.branches.map(branch => {
            mappedZipOptions.push(branch)
          })
        }
        if (this.fundMapCompany.sites) {
          this.fundMapCompany.sites.map(site => {
            mappedZipOptions.push(site)
          })
        }
      }

      return mappedZipOptions.slice(0, 6)
    },
    getBalanceSheetTotal() {
      if (this.fundMapCompany.financeData && this.fundMapCompany.financeData.length) {
        const eszkozok = this.fundMapCompany.financeData.find(financeItem => financeItem.name === 'Eszközök összesen')

        const lastYearEszkozok = eszkozok.data[eszkozok.data.length - 1]
        const result = {
          value: lastYearEszkozok.value * lastYearEszkozok.multiplier,
          currency: lastYearEszkozok.currency
        }
        return result.value
      }
      return ''
    },
    attributesToCalculate() {
      if (!this.fundMapCompany || this.fundMapCompany.imaginaryCompany) {
        return []
      }
      return [
        {
          title: 'Nettó árbevétel',
          amount: this.fundMapCompany.revenue[0].netto_income,
          measurement: this.fundMapCompany.revenue[0].currency,
          keyInStore: 'revenue'
        },
        {
          title: 'Mérlegfőösszeg',
          amount: this.getBalanceSheetTotal,
          measurement: this.fundMapCompany.balanceSheetTotal.data[0].currency,
          keyInStore: 'balanceSheetTotal'
        },
        {
          title: 'Export árbevétel',
          amount: this.fundMapCompany.latestExportRevenue,
          measurement: 'HUF',
          keyInStore: 'latestExportRevenue'
        },
        {
          title: 'Átlagos statisztikai létszám',
          amount: this.fundMapCompany.head_count[0].count,
          measurement: 'fő',
          keyInStore: 'head_count'
        }
      ]
    },
    isAnotherZipButNotSelected() {
      return this.selectedZip == 'Egyéb-zip' && this.fundMapCompanyAttributes.zip == null
    },
    isAnotherTeaorButNotSelected() {
      return this.selectedTeaor == 'Egyéb-teaor' && this.fundMapCompanyAttributes.teaor == null
    }
  },
  methods: {
    calculatorAlreadySelected(key) {
      if (key === 'revenue' && this.fundMapCompanyAttributes && this.fundMapCompanyAttributes.revenue) {
        return this.fundMapCompanyAttributes.revenue
      }
      if (
        key === 'balanceSheetTotal' &&
        this.fundMapCompanyAttributes &&
        this.fundMapCompanyAttributes.balanceSheetTotal
      ) {
        return this.fundMapCompanyAttributes.balanceSheetTotal
      }
      if (
        key === 'latestExportRevenue' &&
        this.fundMapCompanyAttributes &&
        this.fundMapCompanyAttributes.latestExportRevenue
      ) {
        return this.fundMapCompanyAttributes.latestExportRevenue
      }
      if (key === 'head_count' && this.fundMapCompanyAttributes && this.fundMapCompanyAttributes.head_count) {
        return this.fundMapCompanyAttributes.head_count
      }
      return ''
    },
    scrollToTop() {
      document.body.scrollTop = 0 // For Safari
      document.documentElement.scrollTop = 0 // For Chrome, Firefox, IE and Opera
    },
    addCompanyAttribute(key, value) {
      this.$store.dispatch('setCompanyAttributeAction', { [key]: value })
    },
    deleteCompanyAttribute(key) {
      this.$store.dispatch('nullifyCompanyAttributeAction', key)
    },
    prev() {
      if (this.fundMapCompany.imaginaryCompany) {
        this.$router.push('/fund-map/imaginary-company-details')
      } else {
        this.$router.push(`/fund-map/company-details?companyId=${this.fundMapCompany.flaggerId}`)
      }
    },
    next() {
      if (this.isAnotherZipButNotSelected || this.isAnotherTeaorButNotSelected) {
        if (this.isAnotherZipButNotSelected) {
          this.showZipComponentErrorMessage = true
        }
        if (this.isAnotherTeaorButNotSelected) {
          this.showTeaorComponentErrorMessage = true
        }
        this.errorToast('A továbblépéshez töltse ki a megjelölt mezőket!')
      } else {
        this.scrollToTop()
        this.$store.dispatch('nextStepAction')
      }
    },
    mapActivityToCheckbox(activityArray) {
      return activityArray.map(activity => ({ text: activity.nace_name, value: activity.nace_number }))
    },
    mapNameToTeaorCode(teaorCode) {
      const teaor = this.teaorList.find(row => row.teaorValue === teaorCode.toString())
      return teaor ? teaor.labelText : 'Ismeretlen tevékenységi kör'
    },
    addOtherTeaor(teaor) {
      this.addCompanyAttribute('teaor', teaor)
      this.showTeaorComponentErrorMessage = false
    },
    addOtherZip(zip) {
      this.addCompanyAttribute('zip', zip.toString())
      this.showZipComponentErrorMessage = false
    },
    handleMultipliedAttribute(emittedObj) {
      this.addCompanyAttribute(emittedObj.key, emittedObj.value)
    },
    handleRestrictions(ids) {
      this.addCompanyAttribute('restrictions', { competitionIds: ids })
    }
  },
  watch: {
    selectedTeaor() {
      if (this.selectedTeaor !== 'Egyéb-teaor') {
        this.addCompanyAttribute('teaor', this.selectedTeaor)
        this.showTeaorComponentErrorMessage = false
      }
      if (this.selectedTeaor == 'Egyéb-teaor' && this.alreadySelectedTeaor == '') {
        this.deleteCompanyAttribute('teaor')
      }
    },
    selectedZip() {
      if (this.selectedZip !== 'Egyéb-zip') {
        if (!this.fundMapCompany.imaginaryCompany) {
          this.addCompanyAttribute('zip', this.selectedZip.address_zip.toString())
          this.addCompanyAttribute('address', this.selectedZip)
          this.showZipComponentErrorMessage = false
        } else {
          this.addCompanyAttribute('zip', this.selectedZip.toString())
        }
      }
      if (this.selectedZip == 'Egyéb-zip' && this.alreadySelectedZip == '') {
        this.deleteCompanyAttribute('zip')
      }
    },
    isSupplier() {
      if (this.isSupplier) {
        this.addCompanyAttribute('isSupplier', this.isSupplier)
      } else {
        this.deleteCompanyAttribute('isSupplier')
      }
    },
    revenueFromAggriculture() {
      if (this.revenueFromAggriculture) {
        this.addCompanyAttribute('revenueFromAggriculture', this.revenueFromAggriculture)
      } else {
        this.deleteCompanyAttribute('revenueFromAggriculture')
      }
    }
  },
  async created() {
    try {
      this.applications = await CompetitionApi.getRistrictionsByCompetitions()
    } catch (e) {
      console.log(e)
    }
  },
  beforeMount() {
    if (!this.fundMapCompany.imaginaryCompany) {
      this.selectedTeaor = this.fundMapCompany.main_activities[0].nace_number
      this.selectedZip = this.fundMapCompany.address[0]
    } else {
      if (this.fundMapCompanyAttributes && this.fundMapCompanyAttributes.teaor) {
        this.selectedTeaor = this.fundMapCompanyAttributes.teaor
      } else {
        this.selectedTeaor = this.fundMapCompany.imaginaryCompany.mainTeaor
      }

      if (this.fundMapCompanyAttributes && this.fundMapCompanyAttributes.zip) {
        this.selectedZip = this.fundMapCompanyAttributes.zip
      } else {
        this.selectedZip = this.fundMapCompany.imaginaryCompany.address
      }
    }

    if (!this.fundMapCompany.imaginaryCompany) {
      if (this.fundMapCompanyAttributes && this.fundMapCompanyAttributes.zip) {
        if (this.fundMapCompany && this.fundMapCompany.address[0].address_zip == this.fundMapCompanyAttributes.zip) {
          if (this.fundMapCompanyAttributes && this.fundMapCompanyAttributes.address) {
            this.selectedZip = this.fundMapCompanyAttributes.address
          }
        } else {
          this.selectedZip = 'Egyéb-zip'
          this.alreadySelectedZip = this.fundMapCompanyAttributes.zip
        }
      }
      if (this.fundMapCompanyAttributes && this.fundMapCompanyAttributes.teaor) {
        let foundTeaorInTeaorOptions = false

        this.teaorOptions.map(option => {
          if (option.value.toString() == this.fundMapCompanyAttributes.teaor.toString()) {
            this.selectedTeaor = this.fundMapCompanyAttributes.teaor
            return (foundTeaorInTeaorOptions = true)
          }
        })
        if (!foundTeaorInTeaorOptions) {
          this.selectedTeaor = 'Egyéb-teaor'
          this.alreadySelectedTeaor = this.fundMapCompanyAttributes.teaor
        }
      }
      if (this.fundMapCompanyAttributes && this.fundMapCompanyAttributes.isSupplier) {
        this.isSupplier = this.fundMapCompanyAttributes.isSupplier
      }
      if (this.fundMapCompanyAttributes && this.fundMapCompanyAttributes.revenueFromAggriculture) {
        this.revenueFromAggriculture = this.fundMapCompanyAttributes.revenueFromAggriculture
      }
      if (this.fundMapCompany) {
        this.selectedCompany = this.fundMapCompany
      }
      if (this.selectedFundMapCategory) {
        this.selectedCategories = this.selectedFundMapCategory
      }
      this.isLoggedIn = this.isAuthenticated
    } else {
      if (this.fundMapCompanyAttributes && this.fundMapCompanyAttributes.teaor) {
        let imaginaryTeaors = []
        imaginaryTeaors.push(this.fundMapCompany.imaginaryCompany.mainTeaor)
        this.fundMapCompany.imaginaryCompany.secondaryTeaors.forEach(teaor => imaginaryTeaors.push(teaor.teaorCode))

        if (imaginaryTeaors.includes(this.fundMapCompanyAttributes.teaor)) {
          this.selectedTeaor = this.fundMapCompanyAttributes.teaor
        } else {
          this.selectedTeaor = 'Egyéb-teaor'
          this.alreadySelectedTeaor = this.fundMapCompanyAttributes.teaor
        }
      }
      if (this.fundMapCompanyAttributes && this.fundMapCompanyAttributes.zip) {
        let imaginaryZips = []
        imaginaryZips.push(this.fundMapCompany.imaginaryCompany.address)
        this.fundMapCompany.imaginaryCompany.sites.forEach(site => imaginaryZips.push(site.zipCode))

        if (imaginaryZips.includes(this.fundMapCompanyAttributes.zip)) {
          this.selectedZip = this.fundMapCompanyAttributes.zip
        } else {
          this.selectedZip = 'Egyéb-zip'
          this.alreadySelectedZip = this.fundMapCompanyAttributes.zip
        }
      }
      if (this.fundMapCompanyAttributes && this.fundMapCompanyAttributes.isSupplier) {
        this.isSupplier = this.fundMapCompanyAttributes.isSupplier
      }
      if (this.fundMapCompanyAttributes && this.fundMapCompanyAttributes.revenueFromAggriculture) {
        this.revenueFromAggriculture = this.fundMapCompanyAttributes.revenueFromAggriculture
      }
    }

    if (!this.fundMapCompanyAttributes.revenueFromAggriculture) {
      this.addCompanyAttribute('revenueFromAggriculture', false)
    }
    if (!this.fundMapCompanyAttributes.isSupplier) {
      this.addCompanyAttribute('isSupplier', false)
    }

    if (this.fundMapCompanyAttributes && this.fundMapCompanyAttributes.restrictions.length > 0) {
      this.restrictions = this.fundMapCompanyAttributes.restrictions
    }
  }
}
</script>

<style scoped>
.sub-header {
  font-weight: 500;
  font-size: 12px;
}

.table-title-header {
  font-weight: 700;
  font-size: 16px;
}

.radio-text {
  font-weight: 400;
  font-size: 14px;
  color: #2d3436;
  text-transform: none;
  margin-bottom: 0px;
}

input[type='radio'] {
  min-width: 20px;
  min-height: 20px;
  border: 1px solid #bbc1d3;
}

input[type='radio']:after {
  border-radius: 10px;
  content: '';
  display: inline-block;
}

input[type='radio']:checked:after {
  min-width: 20px;
  min-height: 20px;
  background-color: white;
  border: 6px solid #00903c;
}
.radio-box {
  height: 40px;
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.checkbox-label {
  font-size: 14px;
  font-weight: 400;
  color: #2d3436;
}

.disclaimer {
  margin-top: 20px;
  font-size: 11px;
  font-weight: 500;
  color: #636e72;
}
@media screen and (min-width: 1200px) {
  .checkbox-label {
    font-size: 16px;
  }

  .radio-text {
    font-size: 16px;
  }
}
</style>
